import axios from "axios";
import { GetTopMoversRequestType, GetTopMoversResponseType } from "../types/rank.type";
import { Geography, RankType } from "../utils/type";
import { apiBase } from './apiBase';
export const getTopMoversData = ({ geography: Geography, rankType: RankType, token: string }: GetTopMoversRequestType): Promise<GetTopMoversResponseType> => {
    return new Promise(async (resolve, reject) => {
        axios
            .get(`${apiBase()}/ranking/`, {
                params: { geog: Geography, rankType: RankType, token: string },
            })
            .then((res) => {
                if (res.data) {
                    resolve(res.data);
                } else {
                    resolve(undefined as any);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};